module.exports = __webpack_public_path__ + "static/Delivery_Continuo-f43a1663fdacab5f910b411ca0527beb.png";